<template>
  <v-container fluid>
    <v-row class="px-8 pt-1">
      <v-col cols="3" class="pr-4 pl-3">
        <v-btn depressed color="primary" @click="create">
          <span>Ajouter</span>
        </v-btn>
      </v-col>
      <v-col cols="9">
        <v-row>
          <v-col cols="4" class="py-0">
            <v-row justify="space-around">
              <v-checkbox
                      class="label my-0 py-0"
                      label="De Bac à Bac+3"
                      :value="3"
                      v-model="searchByDegreeType"
              ></v-checkbox>
              <v-checkbox
                      class="label my-0 py-0"
                      label="De Bac+3 à Bac+6"
                      :value="1"
                      v-model="searchByDegreeType"
              ></v-checkbox>
            </v-row>
          </v-col>
          <v-col cols="4" class="pt-0">
            <div class="d-flex align-center justify-end">
              <v-select
                      v-model="searchByTopic"
                      :items="topics"
                      :disabled="!searchByDegreeType"
                      item-value="id"
                      item-text="name"
                      hide-details
                      outlined
                      label="Topic"
                      no-data-text="Pas de données disponibles"
                      clearable
              >
              </v-select>
            </div>
          </v-col>
          <v-col cols="4" class="pt-0">
            <v-text-field
                    label="Titre"
                    hide-details
                    outlined
                    dense
                    @keydown="checkEnter"
                    v-model="searchByTitle"
            >
              <template v-slot:append>
                <v-btn
                        depressed
                        color="primary"
                        class="topBar-search ma-0"
                        @click="getAdviceDetailByTitle"
                >
                  <v-icon v-text="'fas fa-search'"></v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <TableDefault
      :headers="headers"
      :items="items"
      :totalPage="totalPage"
      :totalItem="totalItem"
      :limit="limit"
      :currentPage="currentPage"
      :content="content"
      @getContent="getContent"
      @edit="getAdviceDetailEdit"
      @remove="remove"
      @changePage="changePage"
      @changeItemPerPage="changeItemPerPage"
    />
  </v-container>
</template>

<script>
import TableDefault from "@/components/tables/TableDefault";
import adviceDetailService from "@/services/adviceDetail";
import adviceService from "@/services/advice";

export default {
  name: "News",
  components: { TableDefault },
  data: () => ({
    content: '',
    headers: [
      {
        text: "ID",
        field: "id",
        width: "50px"
      },
      {
        text: "Niveau",
        field: "degreeType.name",
        width: "200px"
      },
      {
        text: "Catégories",
        field: "advice.name",
      },
      {
        text: "Articles",
        field: "name",
      },
      {
        text: "Action",
        action: true,
        hiddenEdit: false,
        width: "130px"
      }
    ],
    items: [],
    topics: [],
    totalPage: 1,
    totalItem: 0,
    currentPage: 1,
    limit: 50,
    searchByTitle: "",
    searchByTopic: "",
    searchByDegreeType: "",
  }),
  created() {
    this.getAdviceDetail();
  },
  methods: {
    checkEnter(event) {
      if (event.code === "Enter") {
        this.getAdviceDetail();
      }
    },
    changePage(page) {
      this.currentPage = page;
      this.getAdviceDetail();
    },
    changeItemPerPage(limit) {
      this.limit = limit;
      this.getAdviceDetail();
    },
    create() {
      this.$store.dispatch("resetAdviceDetail");
      this.$router.push({ name: "AdviceDetailCreate" });
    },
    async getAdvicesByDegreeType() {
      let res = await adviceService.getAdvicesByDegreeType({
        degreeType: this.searchByDegreeType
      });
      if (res) {
        this.topics = res.data;
      }
    },
    async getAdviceDetail() {
      let res = await adviceDetailService.getAdviceDetailPagination({
        limit: this.limit,
        currentPage: this.currentPage,
        searchByTitle: this.searchByTitle,
        searchByTopic: this.searchByTopic,
        searchByDegreeType: this.searchByDegreeType
      });
      if (res) {
        this.items = res.data.data;
        this.totalPage = res.data.totalPage;
        this.totalItem = res.data.totalItem;
      }
    },
    async getContent(id) {
      this.content = '';
      let res = await adviceDetailService.getDetail(id);
      if (res) {
        this.content = res.data.content;
      }
    },
    getAdviceDetailByTitle() {
      this.currentPage = 1;
      this.getAdviceDetail();
    },
    async getAdviceDetailEdit(adviceDetail) {
      let res = await adviceDetailService.getDetail(adviceDetail.id);
      if (res) {
        this.$store.dispatch("setAdviceDetail", res.data);
        this.$router.push({
          name: "AdviceDetailEdit"
        });
      }
    },
    async remove(adviceDetail) {
      await this.$store.dispatch("removeAdviceDetail", adviceDetail);
      this.getAdviceDetail();
    }
  },
  watch: {
    searchByDegreeType: function (value) {
      if (value === null) {
        this.searchByDegreeType = "";
      }
      this.currentPage = 1;
      this.getAdviceDetail();
      this.getAdvicesByDegreeType();
    },
    searchByTopic: function (value) {
      if (value === undefined) {
        this.searchByTopic = "";
      }
      this.currentPage = 1;
      this.getAdviceDetail();
    },
  }
};
</script>
<style lang="sass">
.v-menu__content
    .v-card
        margin: 0
    .radio-group .col
        padding: 0 12px
    .v-input--selection-controls .v-radio>.v-label
        color: #000
        font-weight: 400
    .v-input__icon
        height: 18px
</style>
